import { Head } from "@inertiajs/react"
import ProductionHeader from "@/components/admin/production/ProductionHeader"
import BatchForm from "@/components/admin/production/BatchForm"
import type {
  AssetOption,
  AssetUsageRow,
  BatchVariantRow,
  CostLineRow,
  SharedProductionProps,
  VariantOption,
} from "@/components/admin/production/types"

interface BatchDetail {
  id: number
  label: string
  produced_on: string
  notes: string | null
  variants: BatchVariantRow[]
  cost_lines: CostLineRow[]
  asset_usages: AssetUsageRow[]
}

interface EditProps extends SharedProductionProps {
  batch: BatchDetail
  item_variants: VariantOption[]
  active_assets: AssetOption[]
  cost_kinds: string[]
  errors?: Record<string, string[]>
}

export default function BatchEdit({
  store,
  paths,
  batch,
  item_variants,
  active_assets,
  cost_kinds,
  errors,
}: EditProps) {
  return (
    <>
      <Head title={`Éditer ${batch.label}`} />
      <ProductionHeader
        title={`Éditer ${batch.label}`}
        storeName={store.name ?? undefined}
        paths={paths}
      />
      <main className="mx-auto max-w-4xl px-6 py-8">
        <BatchForm
          initial={{
            label: batch.label,
            produced_on: batch.produced_on,
            notes: batch.notes ?? "",
            variants: batch.variants,
            cost_lines: batch.cost_lines,
            asset_usages: batch.asset_usages,
          }}
          item_variants={item_variants}
          active_assets={active_assets}
          cost_kinds={cost_kinds}
          submitUrl={`${paths.batches_index}/${batch.id}`}
          method="patch"
          errors={errors}
          cancelUrl={`${paths.batches_index}/${batch.id}`}
        />
      </main>
    </>
  )
}
